import { has } from 'lodash-es';
import { Store } from 'vuex';

const STORE_NAMES_CUSTOM_MAPPER = {
  // event.subsystem[event.type] => storeName
  compute: {
    nodes: 'computeNodes'
  }
};

function checkIsInActionsMap({ state, event, actionsMap, $can }: { state: RootState, event: SocketEvent, actionsMap: Record<string, object>, $can: (a: string, b: string) => boolean }): string {
  let errorMessage;

  if (!actionsMap[event.type]?.[event.operation]?.actionName) {
    errorMessage = 'Notification is not mapped';
  } else if (actionsMap[event.type][event.operation].ability
    && !$can(actionsMap[event.type][event.operation].ability.action, actionsMap[event.type][event.operation].ability.subject)) {
    errorMessage = 'User has not abilities to dispatch notificated action';
  } else if (!has(state, actionsMap[event.type][event.operation].moduleName)) {
    errorMessage = 'Notification try to use unexistant state';
  } else if (actionsMap[event.type][event.operation].process && !actionsMap[event.type][event.operation].process?.(event.object)) {
    errorMessage = 'Not allowed to process notification';
  }

  return errorMessage;
}

async function tryToDispatchOperationAction({ event, state, dispatch, commit }: { event: SocketEvent, state: RootState, dispatch: Store<RootState>['dispatch'], commit: Store<RootState>['commit'] }): Promise<any> {
  // TODO event.type may be different with actual store name.
  // Apply CHANGE action on every notification if module exists
  // Use state name to event.type mapper
  const storeModuleName = STORE_NAMES_CUSTOM_MAPPER[event.subsystem]?.[event.type] || event.type;

  if (storeModuleName && state[storeModuleName]) {
    const customAction = `socket_${event.operation}`;
    const customActionNamespaced = `${storeModuleName}/socket_${event.operation}`;
    const socketActionIsExists = state[storeModuleName].availableActions?.indexOf(customAction) > -1;

    if (socketActionIsExists) {
      return dispatch(customActionNamespaced, event.object, { root: true });
    }
    switch (event.operation) {
      case 'deleted':
        return commit(`${storeModuleName}/REMOVE`, event.object.id, { root: true });
      case 'updated':
        await dispatch(`${storeModuleName}/CHANGE`, event.object, { root: true });
        return dispatch(`${storeModuleName}/FETCH_ITEM`, { id: event.object.id }, { root: true });
      case 'failed':
        return dispatch(`${storeModuleName}/FETCH_ITEM`, { id: event.object.id }, { root: true });
      case 'created':
      default:
        return dispatch(`${storeModuleName}/FETCH_ITEM`, { id: event.object.id }, { root: true });
    }
  }

  return Promise.reject(`Unable to find proper state for notification event type '${storeModuleName}'`);
}

export { checkIsInActionsMap, tryToDispatchOperationAction };
